import { actionTextColor, readableText } from "../../utils/themeContrast";
import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { IoIosAdd, IoIosRemove } from "react-icons/io";
import { IoTrashOutline } from "react-icons/io5";

import { UserContext, ThemeContext, LanguageContext } from "../../contexts/Context";
import QuantityRecAdjust from "./QuantityRecAdjust";
import ItemSize3 from "./ItemSize3";
import { getMenuAvailabilityInfo } from "../../utils/menuAvailability";
const MenuItem = ({
  item,
  handleOnClick,
  containerWidth,
  containerHeight,
  active,
  isSetMeal,
  hasRecommended,
  adjustQuantity,
  theme,
  lanIndex,
  isLanReverse,
  currencySymbol,
  selectedItems,
  addQty,
  minusQty,
  addItemDirect,
  cp,
  shouldHide,
  menuListCard = false,
  recommendationCard = false,
  compactDesktop = false
}) => {
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { tax, displayNetAmount, hidePrice, customer, hideLimitedTimeInfo, displayMenuDescription, isMenuView } = React.useContext(UserContext);
  const ref = useRef(null);
  const [codeId, setCodeId] = useState("");
  const [hasCustomer, setHasCustomer] = useState(false);
  const [hasPricebook, setHasPricebook] = useState(false);
  const availabilityInfo = hideLimitedTimeInfo ? null : getMenuAvailabilityInfo(item);
  useEffect(() => {
    if (item.codeId != codeId) {
      if (!shouldHide) return;
      if (ref.current == null) return;
      if (ref.current.getBoundingClientRect().top <= window.innerHeight) {
        ref.current.style.backgroundImage = `url('${ref.current.dataset.bg}')`;
      }
      setCodeId(item.codeId);
      if (typeof item.pricebook != 'undefined' && Object.keys(item.pricebook).length > 0 && item.pricebook[Object.keys(item.pricebook)[0]].minQty == 1) {
        setHasPricebook(true);
        if (customer)
          setHasCustomer(true);
      }
    }
  }, [codeId, item.codeId]);

  useEffect(() => {
    if (!shouldHide) return;
    if (ref.current == null) return;
    if (ref.current.getBoundingClientRect().top < window.innerHeight) {
      ref.current.style.backgroundImage = `url('${ref.current.dataset.bg}')`;
      ref.current.classList.remove('item-img');
    }

  }, []);

  const isDesktop = typeof window !== "undefined" && window.innerWidth >= 768;
  const displaySize = isDesktop && Number(item.size) === 1 ? 0 : item.size;
  const enlargeMobileListImage = menuListCard && Number(cp) === 0 &&
    Number(displaySize) === 1 && displayMenuDescription !== true && displayMenuDescription !== "true";
  const usePrimaryLanguage = (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse);
  const localizedDescription = recommendationCard
    ? (usePrimaryLanguage ? (item.description || item.description2) : (item.description2 || item.description))
    : (usePrimaryLanguage ? item.description : (item.description2 || item.description));

  return (
    <>
      <ItemContainer
        height={containerHeight}
        width={containerWidth}
        hideDisplay={item.hideDisplay}
        active={active}
        size={displaySize}
        themeContext={themeContext}
        theme={theme}
        cp={cp}
        menuListCard={menuListCard}
        hasSelectedQty={Boolean(selectedItems && selectedItems[item.codeId])}
        recommendationCard={recommendationCard}
        hasRecommended={hasRecommended}
        style={{ width: menuListCard ? containerWidth : (displaySize == 1 || displaySize == 2 || displaySize == 3 ? containerWidth * 2 : containerWidth), margin: '' }}
        onClick={(e) => {
          e.stopPropagation();
          if (!item.isSoldOut) {
            handleOnClick();
          }
        }}
      >
        {displaySize == 3 && //horizontal new layout
          <ItemSize3
            lanIndex={lanIndex}
            isLanReverse={isLanReverse}
            item={item}
            shouldHide={shouldHide}
            isSetMeal={isSetMeal}
            selectedItems={selectedItems}
            addItemDirect={addItemDirect}
            currencySymbol={currencySymbol}
            cp={cp}
            addQty={addQty}
            minusQty={minusQty}
          />
        }
        {displaySize != 3 &&
          <React.Fragment>
            {displaySize != 2 &&
              <ItemDisplay
                // key={columnIndex + rowIndex * 2}
                ref={ref}
                key={item.codeId}
                className="item-img menu-card-image"
                data-bg={item.image}
                shouldHide={shouldHide}
                menuListCard={menuListCard}
                recommendationCard={recommendationCard}
                enlargeMobileImage={enlargeMobileListImage}
                size={displaySize}
              >
                {item.isSoldOut &&
                  <SoldOut src="/soldout.png" />
                }
                <IconHolder icons={item.icons} enlarge={cp == 1 && !hasRecommended} />
                {!menuListCard && (typeof item.comparePrice != 'undefined' && item.comparePrice > 0 && !hidePrice) &&
                  <ComparePriceDisplay themeContext={themeContext} enlarge={cp == 1 && !hasRecommended}>
                    {`${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.comparePrice * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.comparePrice).toFixed(2)}`}
                  </ComparePriceDisplay>
                }
                {!menuListCard && item.price > 0 && !hidePrice &&
                  <PriceDisplay themeContext={themeContext} enlarge={cp == 1 && !hasRecommended} hasCustomer={hasCustomer}>
                    {`${!hasCustomer && hasPricebook ? "ORI:" : ""} ${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.price * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.price).toFixed(2)}`}
                  </PriceDisplay>
                }
                {!menuListCard && (hasPricebook && item.pricebook[Object.keys(item.pricebook)[0]]) &&
                  <PricebookDisplay themeContext={themeContext}>
                    {`${item.pricebook[Object.keys(item.pricebook)[0]].title}: ${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.pricebook[Object.keys(item.pricebook)[0]].price * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.pricebook[Object.keys(item.pricebook)[0]].price).toFixed(2)}`}
                  </PricebookDisplay>
                }
              </ItemDisplay>
            }
            {(!menuListCard && !hasRecommended && selectedItems && selectedItems[item.codeId] && addItemDirect) &&
              <ItemQtyWrapper size={displaySize}>
                <ItemQtyIcon onClick={minusQty} enlarge={cp == 1 && !hasRecommended}><IoIosRemove size={24} /></ItemQtyIcon>
                <ItemQtyTxt themeContext={themeContext} size={displaySize} enlarge={cp == 1 && !hasRecommended}>{selectedItems[item.codeId]}</ItemQtyTxt>
                <ItemQtyIcon onClick={addQty} enlarge={cp == 1 && !hasRecommended}><IoIosAdd size={24} /></ItemQtyIcon>
              </ItemQtyWrapper>
            }
            {(!menuListCard && !hasRecommended && selectedItems && selectedItems[item.codeId] && (!addItemDirect)) &&
              <ItemQty themeContext={themeContext} size={displaySize} enlarge={cp == 1 && !hasRecommended}>x{selectedItems[item.codeId]}</ItemQty>
            }
            {(displaySize != 2 || menuListCard) &&
              <ItemTitleWrapper
                className="menu-card-content"
                themeContext={themeContext}
                size={displaySize}
                cp={cp}
                enlarge={cp == 1 && !hasRecommended}
                menuListCard={menuListCard}
                recommendationCard={recommendationCard}
                compactDesktop={compactDesktop}
                title={item.title}
                reservePriceSpace={!hidePrice && !item.isCategory}
                reserveDescriptionSpace={displayMenuDescription === true || displayMenuDescription === "true"}
              >
                <ItemTitle themeContext={themeContext} title={item.title} theme={theme} enlarge={cp == 1 && !hasRecommended} menuListCard={menuListCard} recommendationCard={recommendationCard} compactDesktop={compactDesktop}>
                  {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
                    (item.isCategory ? item.category : item.title) :
                    (item.isCategory ? item.category2 : item.title2)
                  }
                </ItemTitle>
                {menuListCard && !item.isCategory && !hidePrice &&
                  <ItemPriceGroup>
                    {(typeof item.comparePrice != 'undefined' && item.comparePrice > 0) &&
                      <ComparePriceDisplay menuListCard themeContext={themeContext} enlarge={cp == 1 && !hasRecommended}>
                        {`${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.comparePrice * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.comparePrice).toFixed(2)}`}
                      </ComparePriceDisplay>
                    }
                    {item.price > 0 &&
                      <PriceDisplay menuListCard themeContext={themeContext} enlarge={cp == 1 && !hasRecommended} hasCustomer={hasCustomer}>
                        {`${!hasCustomer && hasPricebook ? "ORI:" : ""} ${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.price * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.price).toFixed(2)}`}
                      </PriceDisplay>
                    }
                    {(hasPricebook && item.pricebook[Object.keys(item.pricebook)[0]]) &&
                      <PricebookDisplay menuListCard themeContext={themeContext}>
                        {`${item.pricebook[Object.keys(item.pricebook)[0]].title}: ${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.pricebook[Object.keys(item.pricebook)[0]].price * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.pricebook[Object.keys(item.pricebook)[0]].price).toFixed(2)}`}
                      </PricebookDisplay>
                    }
                  </ItemPriceGroup>
                }
                {menuListCard && !item.isCategory && (displayMenuDescription === true || displayMenuDescription === "true") &&
                  <ItemDescription className="menu-card-description" themeContext={themeContext} recommendationCard={recommendationCard}>
                    {localizedDescription}
                  </ItemDescription>
                }
                {menuListCard && displaySize == 2 && availabilityInfo &&
                  <ItemAvailabilityBadge isUnavailable={availabilityInfo.isUnavailable}>
                    {availabilityInfo.text}
                  </ItemAvailabilityBadge>
                }
                {menuListCard && displaySize == 2 && item.isSoldOut &&
                  <PlainSoldOut role="status">Sold out</PlainSoldOut>
                }
              </ItemTitleWrapper>
            }
            {menuListCard && !item.isCategory &&
              <ItemActionFooter className="menu-card-actions" themeContext={themeContext} recommendationCard={recommendationCard} compactSidebar={Number(cp) === 0}
                hasPricebook={(hasPricebook && item.pricebook[Object.keys(item.pricebook)[0]])}
              >
                {!isMenuView && selectedItems && selectedItems[item.codeId] ?
                  <CardQuantityControl>
                    <CardRemoveButton
                      type="button"
                      aria-label="Remove one item"
                      onClick={(event) => {
                        event.stopPropagation();
                        minusQty(event);
                      }}
                    >
                      <IoTrashOutline size={18} aria-hidden="true" />
                    </CardRemoveButton>
                    <CardQuantityValue
                      type="button"
                      aria-label={`Quantity ${selectedItems[item.codeId]}. Add another item`}
                      disabled={item.isSoldOut}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (!item.isSoldOut) addQty();
                      }}
                    >
                      {selectedItems[item.codeId]}
                    </CardQuantityValue>
                  </CardQuantityControl>
                  :
                  !isMenuView &&
                  <ItemAddButton
                    type="button"
                    themeContext={themeContext}
                    compactSidebar={menuListCard && Number(cp) === 0 && !recommendationCard}
                    recommendationCard={recommendationCard}
                    aria-label={(languageContext[lanIndex] && languageContext[lanIndex].add) || "Add"}
                    disabled={item.isSoldOut}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (!item.isSoldOut) addQty();
                    }}
                  >
                    <IoIosAdd size={24} aria-hidden="true" />
                  </ItemAddButton>
                }
              </ItemActionFooter>
            }
            {displaySize == 2 && !menuListCard &&
              <ItemTextOnly themeContext={themeContext} enlarge={cp == 1 && !hasRecommended}>
                {item.isSoldOut &&
                  <SoldOut2 src="/soldout.png" />
                }
                <ItemPlainWrapper>
                  <ItemPlainTitle enlarge={cp == 1 && !hasRecommended}>
                    {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
                      (item.isCategory ? item.category : item.title) :
                      (item.isCategory ? item.category2 : item.title2)
                    }
                  </ItemPlainTitle>
                  {(displayMenuDescription === true || displayMenuDescription === "true") && localizedDescription &&
                    <ItemPlainDescription size={displaySize}>
                      {localizedDescription}
                    </ItemPlainDescription>
                  }
                  {availabilityInfo &&
                    <ItemAvailabilityBadge isUnavailable={availabilityInfo.isUnavailable}>
                      {availabilityInfo.text}
                    </ItemAvailabilityBadge>
                  }
                </ItemPlainWrapper>
                <ItemPrice enlarge={cp == 1 && !hasRecommended}>
                  {`${isSetMeal ? "+" : ""}${currencySymbol} ${(displayNetAmount ? (item.price * (1 + tax.tax)) : item.price).toFixed(2)}`}
                </ItemPrice>
              </ItemTextOnly>

            }
          </React.Fragment>
        }
      </ItemContainer>
      {(hasRecommended && item.qty > 0) &&
        <QuantityRecAdjust
          size={32}
          quantity={item.qty ? item.qty : 1}
          adjustQuantity={adjustQuantity}
        />
      }
    </>
  );
};

export default MenuItem;

const IconHolder = ({ icons, enlarge }) => {
  const userContext = React.useContext(UserContext);
  return (
    <IconsContainer enlarge={enlarge}>
      {Array.isArray(icons) && icons.map((iconsLink, index) => (
        <Icons
          enlarge={enlarge}
          key={index + iconsLink + "Icons"}
          iconsLink={iconsLink}
          iconsImg={userContext.icons}
        />
      ))}
    </IconsContainer>
  );
};

const ItemPlainWrapper = styled.div`
  flex-grow:1;
`;

const PlainSoldOut = styled.span`
  align-self: flex-start;
  margin-top: 6px;
  padding: 3px 8px;
  border-radius: 4px;
  color: #9a2929;
  background: #fff0f0;
  font-size: 11px;
  font-weight: 600;
`;

const ItemPlainTitle = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  flex-grow: 1;
  text-align: left;
  white-space: pre-wrap;
  padding-right: 4px;
  overflow: hidden;
`;

const ItemPlainDescription = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-align: ${(props) => props.size != 2 ? 'center' : 'left'};
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: 12px;
  padding-left: ${(props) => props.size != 2 ? '8px' : '0px'};
  padding-right: ${(props) => props.size != 2 ? '8px' : '16px'};
  color: #9E9E9E;
  font-weight: 300;
  padding-top: 4px;
  margin-bottom: 8px;
`;

const ItemAvailabilityBadge = styled.div`
  display: inline-block;
  max-width: calc(100% - 16px);
  margin-top: 2px;
  margin-right: 16px;
  padding: 3px 6px;
  border-radius: 4px;
  color: ${(props) => props.isUnavailable ? "#9a4b00" : "#0f6b35"};
  background-color: ${(props) => props.isUnavailable ? "rgba(255, 152, 0, 0.14)" : "rgba(29, 145, 74, 0.14)"};
  border: 1px solid ${(props) => props.isUnavailable ? "rgba(255, 152, 0, 0.45)" : "rgba(29, 145, 74, 0.45)"};
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
`;

const ItemQtyTxt = styled.div`
  font-size: ${props => props.enlarge ? 20 : 16}px;
  width: ${props => props.enlarge ? 40 : 32}px;
  height: ${props => props.enlarge ? 40 : 32}px;
  color: white;
  display:flex;
  justify-content: center;
  align-items: center;
`;

const ItemQtyIcon = styled.div`
  width: ${props => props.enlarge ? 40 : 32}px;
  height: ${props => props.enlarge ? 40 : 32}px;
  border-radius: ${props => props.enlarge ? 20 : 16}px; 
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,0.6);
  color: black;
  font-size: 16px;
  font-weight:600;
`;

const ItemQtyWrapper = styled.div`
  display:flex;
  padding: ${(props) => props.size == 1 ? "16px  16px" : "8px 4px"};
  border-radius: 6px;
  background-color: rgba(0,0,0,0.6);
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top:  ${(props) => props.size == 1 ? "40%" : props.size == 2 ? "50%" : "35%"};
  transform: translate(-50%, -50%);
`;

const ItemQty = styled.div`
  position: absolute;
  font-size: ${props => props.enlarge ? 16 : 12}px;
  color: ${(props) => props.themeContext.fontSecondary};
  background-color: ${(props) => props.themeContext.primaryColor}; 
  bottom: ${(props) => {
    if (props.enlarge)
      return props.size != 2 ? 50 : 75
    else
      return props.size != 2 ? 40 : 75
  }}px;
  left: 2px;
  border-radius: ${props => props.enlarge ? 18 : 13}px;
  width:${props => props.enlarge ? 36 : 25}px;
  height:${props => props.enlarge ? 36 : 25}px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 3px rgba(0,0,0,0.65); 
`;

const ItemTextOnly = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.themeContext.fontSecondary};
  font-size: ${props => props.enlarge ? 16 : 12}px;
  font-weight: 400;
  padding: 0px 16px;
`;

const ItemPrice = styled.div`
  white-space: nowrap;
`;

const SoldOut = styled.img`
  width: 100%;
  position: absolute;
  top: 40%;
  left: 0;
  transform: translateY(-50%);
`;
const SoldOut2 = styled.img`
  width: 40%;
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translateX(50%) translateY(-50%);
`;
const Icons = styled.div`
  height: ${props => props.enlarge ? 36 : 30}px;
  width: 56px;
  background-image: url(${(props) => props.iconsImg[props.iconsLink]});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;

  @media (min-width: 768px) {
    height: 42px;
    width: 68px;
  }
`;
const IconsContainer = styled.div`
  position: relative;
  display: block;
  font-size: ${props => props.enlarge ? 28 : 25}px;
  min-width: ${props => props.enlarge ? 36 : 30}px;
  height: ${props => props.enlarge ? 36 : 30}px;

  @media (min-width: 768px) {
    min-width: 42px;
    height: 42px;
  }
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => props.size == 3 ? "row" : "column"};
  flex: ${(props) => props.menuListCard ? "0 0 auto" : "1"};
  position: relative;
  justify-content: ${(props) => props.menuListCard ? "flex-start" : "center"};
  box-sizing: ${(props) => props.menuListCard ? "border-box" : "content-box"};
  overflow: ${(props) => props.menuListCard ? "hidden" : "visible"};
  box-shadow: ${(props) => props.menuListCard ? "0 3px 12px rgba(0, 0, 0, 0.12)" : "0px 0px 4px 0px darkgray"};
  border-radius: ${(props) => props.menuListCard ? "18px" : "8px"};
  margin: ${(props) => props.cp == 1 ? "12px" : "8px"};
  margin-top:${(props) => props.size == 2 ? "0px" : "8px"};
  height: ${(props) => Number(props.size) === 3 || props.menuListCard ? "auto" : (props.height ? props.height + "px" : props.size != 2 ? "90%" : "80%")};
  width: ${(props) => (props.width ? props.width + "px" : "90%")};
  border: ${(props) => props.active ? `3px solid ${props.themeContext.primaryColor}` : (props.menuListCard ? `1px solid ${props.themeContext.borderColor || "#cce2c5"}` : "")};
  opacity: ${(props) => () => {
    if (props.hasRecommended || props.active === undefined) {
      return 1;
    } else {
      return props.active ? 1 : 0.8;
    }
  }};
  z-index:${(props) => props.hideDisplay ? 0 : 1};
  background-color:${(props) => props.menuListCard ? props.themeContext.backgroundColor : (props.size == 2 ? props.themeContext.optionHeaderBackgroundColor : "")};
  transition: ${(props) => props.menuListCard ? "transform 180ms ease, box-shadow 180ms ease" : "none"};

  @media (min-width: 768px) {
    &:hover {
      transform: ${(props) => props.menuListCard ? "translateY(-3px)" : "none"};
      box-shadow: ${(props) => props.menuListCard ? "0 10px 24px rgba(0, 0, 0, 0.16)" : "0px 0px 4px 0px darkgray"};
    }
  }

  @media (max-width: 767px) {
    margin: ${(props) => props.menuListCard && Number(props.cp) === 0 ? "5px" : (props.cp == 1 ? "12px" : "8px")};
    margin-top: ${(props) => props.size == 2 ? "0px" : (props.menuListCard && Number(props.cp) === 0 ? "5px" : "8px")};
    ${props => props.menuListCard && !props.recommendationCard && Number(props.cp) === 0 && (Number(props.size) === 0 || Number(props.size) === 1) && `
      display: grid;
      grid-template-columns: 102px minmax(0, 1fr);
      grid-template-rows: auto;
      min-height: 124px;
      align-items: start;
      border-radius: 14px;
      box-shadow: 0 2px 7px rgba(0, 0, 0, 0.06);
      > .menu-card-image {
        grid-column: 1;
        grid-row: 1;
        width: 88px;
        min-width: 0;
        height: 88px;
        margin: 10px 0 10px 10px;
        aspect-ratio: 1;
        border-radius: 10px;
      }
      > .menu-card-content { grid-column: 2; grid-row: 1; padding: 10px 12px 12px 8px; }
      .menu-card-description { padding-right: ${props.hasSelectedQty ? 68 : 34}px; }
      > .menu-card-actions {
        position: absolute;
        right: 8px;
        bottom: 8px;
        padding: 0;
        background: transparent;
        button { width: 28px; min-width: 28px; height: 28px; padding: 0; font-size: 13px; box-shadow: none; }
        button > svg { width: 18px; height: 18px; }
        > button {
          color: ${props.themeContext.primaryColor};
          background: ${props.themeContext.backgroundColor};
          border: 1px solid ${props.themeContext.primaryColor};
        }
      }
    `}

  }
`;
const ItemDisplay = styled.div`
  display: ${(props) => props.menuListCard ? "block" : "grid"};
  position: relative;
  flex: ${(props) => props.menuListCard ? "0 0 auto" : "1"};
  aspect-ratio: ${(props) => props.menuListCard ? (Number(props.size) === 1 ? "16 / 9" : "6 / 5") : "auto"};
  justify-content: ${(props) => props.menuListCard ? "initial" : "flex-end"};
  border-top-right-radius: ${(props) => props.menuListCard ? "12px" : "6px"};
  border-top-left-radius: ${(props) => props.menuListCard ? "12px" : "6px"};
  width: ${(props) => props.menuListCard ? "100%" : "auto"};
  height: ${(props) => props.menuListCard ? "auto" : "72%"};
  min-width: 100%;
  //Image based on image url in item given
  background-image: url(${(props) => props.shouldHide ? "" : props["data-bg"]});
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;

  @media (max-width: 767px) {
    aspect-ratio: ${(props) => props.enlargeMobileImage ? "5 / 4" : (props.menuListCard ? (Number(props.size) === 1 ? "16 / 9" : "6 / 5") : "auto")};
  }
`;
const ComparePriceDisplay = styled.div`
  position: ${(props) => props.menuListCard ? "static" : "absolute"};
  right: ${(props) => props.menuListCard ? "auto" : "0px"};
  bottom: ${(props) => props.menuListCard ? "auto" : (props.enlarge ? "18px" : "14px")};
  color: ${(props) => props.menuListCard ? readableText(props.themeContext.backgroundColor, "#767676") : props.themeContext.itemPrice};
  text-shadow: ${(props) => props.menuListCard ? "none" : "0px 0px 7px rgba(0,0,0,70%)"};
  z-index: 2;
  font-weight: ${(props) => props.menuListCard ? 500 : 700};
  font-size: ${props => props.enlarge ? 15 : 12}px;
  margin-right: ${(props) => props.menuListCard ? "0" : "10px"};
  text-decoration: line-through;
  ${(props) => props.menuListCard && `
    font-family: ${props.themeContext.fontFamily};
    font-size: var(--menu-item-font-size);
    line-height: 1.3;
  `}
`;
const PriceDisplay = styled.div`
  position: ${(props) => props.menuListCard ? "static" : "absolute"};
  right: ${(props) => props.menuListCard ? "auto" : "0px"};
  bottom: ${(props) => props.menuListCard ? "auto" : "2px"};
  color: ${(props) => props.menuListCard ? readableText(props.themeContext.backgroundColor, props.themeContext.menuItemPriceColor, props.themeContext.fontPrice, "#a3000a") : props.themeContext.itemPrice};
  text-shadow: ${(props) => props.menuListCard ? "none" : "0px 0px 7px #000"};
  font-weight: 700;
  font-size: ${props => props.menuListCard ? (props.enlarge ? 18 : 16) : 14}px;
  margin-right: ${(props) => props.menuListCard ? "0" : "10px"};
  text-decoration: ${(props) => props.hasCustomer ? "line-through" : "none"};
  ${(props) => props.menuListCard && `
    font-family: ${props.themeContext.fontFamily};
    font-size: var(--menu-item-font-size);
    line-height: 1.3;
  `}
`;
const PricebookDisplay = styled.div`
  position: ${(props) => props.menuListCard ? "static" : "absolute"};
  right: ${(props) => props.menuListCard ? "auto" : "0px"};
  bottom: ${(props) => props.menuListCard ? "auto" : "18px"};
  color: ${(props) => props.menuListCard ? readableText(props.themeContext.backgroundColor, props.themeContext.menuItemPriceColor, props.themeContext.fontPrice, "#a3000a") : props.themeContext.itemPrice};
  text-shadow: ${(props) => props.menuListCard ? "none" : "0px 0px 7px rgba(0,0,0,70%)"};
  z-index: 2;
  font-weight: ${(props) => props.menuListCard ? 600 : 700};
  font-size: ${props => props.enlarge ? 14 : 12}px;
  margin-right: ${(props) => props.menuListCard ? "0" : "10px"};
  ${(props) => props.menuListCard && `
    font-family: ${props.themeContext.fontFamily};
    font-size: var(--menu-item-font-size);
    line-height: 1.3;
  `}
`;
const ItemTitleWrapper = styled.div`
  --menu-item-font-size: ${(props) => props.recommendationCard ? "14px" : "15px"};
  @media (min-width: 768px) {
    --menu-item-font-size: ${(props) => props.compactDesktop ? "12px" : "16px"};
  }
  display: ${(props) => props.menuListCard ? "flex" : "grid"};
  flex: ${(props) => props.recommendationCard
    ? `0 0 ${props.reserveDescriptionSpace ? 88 : 48}px`
    : (props.menuListCard ? "1 1 auto" : (props.size == 1 ? "0.2" : "0.3"))};
  min-height: ${(props) => props.recommendationCard
    ? `${props.reserveDescriptionSpace ? 88 : 48}px`
    : "auto"};
  box-sizing: border-box;
  flex-shrink: 0;
  flex-direction: ${(props) => props.menuListCard ? "column" : "row"};
  justify-content: ${(props) => props.menuListCard ? "flex-start" : (props.enlarge ? "flex-start" : "center")};
  padding: ${(props) => props.menuListCard ? (props.recommendationCard ? "9px 10px 0px" : "10px 12px 0px") : "8px 0px"};
  border-bottom-right-radius: ${(props) => props.menuListCard ? "0" : "6px"};
  border-bottom-left-radius: ${(props) => props.menuListCard ? "0" : "6px"};
  border-top: ${(props) => props.menuListCard ? "0" : `1px solid ${props.themeContext.borderColor}`};
  background-color: ${(props) => props.menuListCard ? props.themeContext.backgroundColor : props.themeContext.optionHeaderBackgroundColor};

  @media (min-width: 768px) {
    flex: ${(props) => props.compactDesktop ? "0 0 42px" : undefined};
    flex-basis: ${(props) => props.compactDesktop
    ? "42px"
    : (props.recommendationCard ? `${props.reserveDescriptionSpace ? 100 : 56}px` : "auto")};
    min-height: ${(props) => props.compactDesktop
    ? "42px"
    : (props.recommendationCard ? `${props.reserveDescriptionSpace ? 100 : 56}px` : "auto")};
    max-height: ${(props) => props.compactDesktop ? "42px" : "none"};
    padding: ${(props) => props.compactDesktop
    ? "6px 0"
    : (props.menuListCard ? (props.recommendationCard ? "11px 12px 5px" : "14px 16px 8px") : "8px 0px")};
  }
  ${(props) => props.menuListCard && `
    flex: 0 0 auto;
    min-height: calc(var(--menu-item-font-size) * 2.6 + ${(props.recommendationCard ? 9 : 10) + (props.reservePriceSpace ? 24 : 0) + (props.reserveDescriptionSpace ? (props.recommendationCard ? 38.4 : 41.1) : 0)}px);
    max-height: none;
    @media (min-width: 768px) {
      flex: 0 0 auto;
      min-height: calc(var(--menu-item-font-size) * 2.6 + ${(props.compactDesktop ? 12 : props.recommendationCard ? 16 : 22) + (props.reservePriceSpace ? 28 : 0) + (props.reserveDescriptionSpace ? 49.2 : 0)}px);
      max-height: none;
    }
  `}
`;
const ItemTitle = styled.div`
  display: -webkit-box;
  flex: ${(props) => props.menuListCard ? "none" : "0.3"};
  min-height: ${(props) => props.recommendationCard ? "37px" : "auto"};
  place-content: ${(props) => props.menuListCard ? "initial" : "center"};
  text-align: ${(props) => props.menuListCard ? "left" : (props.enlarge ? "left" : "center")};
  font-weight: ${(props) => props.menuListCard ? 700 : (props.enlarge ? 600 : 400)};
  padding: ${(props) => props.menuListCard ? "0" : `0 ${props.enlarge ? 12 : 8}px`};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: ${(props) => {
    if (props.recommendationCard) {
      return 14;
    } else if (props.menuListCard && props.enlarge) {
      return 15;
    } else if (props.menuListCard) {
      if (props.title && props.title.length > 19) return 14;
      return 15;
    } else if (props.enlarge) {
      return 14;
    } else {
      if (props.theme == 3) {
        return 12;
      } else if (!props.title) {
        return 12;
      } else if (props.title.length > 30) {
        return 12;
      } else if (props.title.length > 19) {
        return 12;
      } else {
        return 12;
      }
    }
  }}px;
  color: ${(props) => props.menuListCard ? readableText(props.themeContext.backgroundColor, props.themeContext.menuItemNameColor, props.themeContext.primaryColor) : props.themeContext.fontSecondary};
  /*min-height: ${(props) => props.enlarge ? 66 : 44}px;
  max-height: ${(props) => props.enlarge ? 66 : 44}px;*/
 
  //Image based on image url in item given
  line-height: ${(props) => props.menuListCard ? "1.3" : "normal"};
  -webkit-line-clamp: ${(props) => props.menuListCard ? 2 : 3};
  word-wrap:break-word;
  -webkit-box-orient: vertical;
  overflow:hidden;
  @media (min-width: 768px) {
    font-size: ${props => props.compactDesktop ? "12px" : "16px"};
  }
  ${(props) => props.menuListCard && `
    font-size: var(--menu-item-font-size);
    height: auto;
    min-height: 0;
  `}
`;

const ItemDescription = styled.div`
  display: -webkit-box;
  height: 2.7em;
  min-height: 2.7em;
  flex-shrink: 0;
  margin-top: 6px;
  color: ${(props) => props.themeContext.descriptionColor || "#777"};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: ${(props) => props.recommendationCard ? "12px" : "13px"};
  font-weight: 400;
  line-height: 1.35;
  text-align: left;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  @media (min-width: 768px) {
    margin-top: 6px;
    font-size: 16px;
    -webkit-line-clamp: 2;
  }
`;

const ItemActionFooter = styled.div`
  display: flex;
  flex: 0 0 auto;
  margin-top: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 10px 10px;
  background: ${(props) => props.themeContext.backgroundColor};
  @media (min-width: 768px) {
    padding: 10px 12px 12px;
  }
`;

const ItemPriceGroup = styled.div`
  display: flex;
  margin-top: 4px;
  flex-shrink: 0;
  min-height: 20px;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  white-space: nowrap;

  @media (min-width: 768px) {
    min-height: 24px;
    justify-content: center;
  }
`;

const ItemAddButton = styled.button`
  display: flex;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  color: ${props => actionTextColor(props.themeContext)};
  background: ${(props) => props.themeContext.primaryColor};
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  @media (min-width: 768px) {
    width: 46px;
    height: 46px;
  }
`;

const CardQuantityControl = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const CardRemoveButton = styled.button`
  display: flex;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #efb4af;
  border-radius: 50%;
  color: #c62828;
  background: #f8e9e7;
  cursor: pointer;
  &:focus-visible { outline: 2px solid #c62828; outline-offset: 2px; }
  @media (min-width: 768px) { width: 46px; height: 46px; }
`;

const CardQuantityValue = styled.button`
  display: flex;
  flex: 0 0 auto;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  align-items: center;
  justify-content: center;
  border: 1px solid #333;
  border-radius: 999px;
  color: #111;
  background: #f7f7f7;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  &:focus-visible { outline: 2px solid #333; outline-offset: 2px; }
  &:disabled { cursor: not-allowed; }
  @media (min-width: 768px) { min-width: 46px; height: 46px; font-size: 18px; }
`;
